import {
	magnificPopupIframe,
	magnificPopupInline,
	magnificPopupSingleImage,
	magnificPopupGalleryImage,
} from "./popups";
import sliders from "./sliders";
import tabs from "./tabs";
import {
	linksCustomization,
	scrollTo,
	responsiveTables,
	notificationPopup,
	smoothScrolling,
	textEditorDetectIframesTogether,
} from "./misc";
import scrollAnimations from "./scrollAnimations";
import setScrollBarWidth from "set-scrollbar-width"; // Use with the Tailwind Container Break Out extension.

// Site wide
import mainMenu from "./mainMenu";
import countDown from "./countDown";

// Templates
import footer from "./footer";
import contact from "./contact";
import news from "./news";
import admissionsProcess from "./admissionsProcess";

/* Flexible Content */
import accordion from "../../templates/blocks/accordion";
import gallery from "../../templates/blocks/gallery";
import blockquote from "../../templates/blocks/blockquote";
import textWithQuote from "../../templates/blocks/text-with-quote";

/* Home grid */
import { home } from "../../templates/sections/home-grid";

function consoleMessage() {
	console.log(
		"%cCreated by %cTWK%cwww.thewebkitchen.co.uk",
		"background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;",
		"background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;",
		"background: #FFFFFF; padding: 5px 10px;"
	);
}

function usingJS() {
	document.querySelector("html").classList.remove("no-js");
	document.querySelector("html").classList.add("js");
}

/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function () {
	// Init
	consoleMessage();
	usingJS();
	setScrollBarWidth();
	linksCustomization();
	scrollTo();
	responsiveTables();
	notificationPopup();
	smoothScrolling();
	scrollAnimations();

	textEditorDetectIframesTogether();

	mainMenu();

	admissionsProcess();
	contact();
	news();
	footer();

	countDown();

	// Popups
	magnificPopupIframe();
	magnificPopupInline();
	magnificPopupSingleImage();
	magnificPopupGalleryImage();

	// Sliders
	sliders();

	tabs();

	// Flexible Content
	accordion();
	gallery();
	blockquote();
	textWithQuote();

	// Home grid
	home();
};

jQuery(document).ready(function ($) {
	ajax: {
		/**
		 * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
		 */
		$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
			magnificPopupIframe();
			magnificPopupInline();
			magnificPopupSingleImage();
			magnificPopupGalleryImage();
		});
	}
});
